module.exports = __webpack_public_path__ + "static/media/roundend.85e29152.png";